(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid-custom"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-video-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    if (window.__fvtInitialised) return;
    window.__fvtInitialised = true;
    document.querySelectorAll('[data-fvt-tile]').forEach(setup);
  }

  function setup(tile) {
    var video = tile.querySelector('.fvt-video');
    var trigger = tile.querySelector('[data-fvt-trigger]');
    var fill = tile.querySelector('.fvt-progress-fill');
    if (!video || !trigger) return;

    video.muted = true;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else if (!tile.classList.contains('is-playing')) {
            video.pause();
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(tile);

    trigger.addEventListener('click', function () {
      var wasPlaying = tile.classList.contains('is-playing');

      document.querySelectorAll('[data-fvt-tile]').forEach(function (other) {
        if (other === tile) return;
        other.classList.remove('is-playing');
        var otherVideo = other.querySelector('.fvt-video');
        if (otherVideo) {
          otherVideo.muted = true;
          otherVideo.currentTime = 0;
          otherVideo.play().catch(function () {});
        }
      });

      if (wasPlaying) {
        tile.classList.remove('is-playing');
        video.muted = true;
      } else {
        tile.classList.add('is-playing');
        video.muted = false;
        video.currentTime = 0;
        video.play().catch(function () {});
      }
    });

    video.addEventListener('timeupdate', function () {
      if (video.duration && fill) {
        fill.style.width = (video.currentTime / video.duration) * 100 + '%';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salkan-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openFromHash() {
      if (!location.hash) return;
      var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target && target.tagName === 'DETAILS') target.open = true;
    }
    window.addEventListener('hashchange', openFromHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
